import React from "react";

export const PASSWORD_VALIDATION_RULE = "Password should be the length of 8 or longer and should contain at least one character out of all of the following categories:";

export const PASSWORD_CHAR_CATEGORIES = [
    <>Lower case and upper case letters</>,
    <>Numbers</>,
    <>Special symbol, such as <span>!@#$%^&*_=+.,/?~</span></>
];